import React, { FC } from 'react';
import {render} from 'react-dom';
const rootEle = document.getElementById('root');
import { getJwtToken, clearJwtToken } from "./stores/loginUtil";
import { aFetch, setAuthtoken } from "./services/api/fetch";
import './i18n';

// Lọc các cảnh báo deprecation nội bộ của thư viện UI bên thứ ba (notistack / Material-UI) trong dev console
if (process.env.NODE_ENV !== 'production') {
    const isIgnoredWarning = (msg: any): boolean => {
        if (typeof msg !== 'string') return false;
        return (
            msg.includes('of `ForwardRef(Snackbar)` is deprecated. Use the `TransitionProps` prop instead') ||
            msg.includes('The prop `rows` of `ForwardRef(TextField)` is deprecated')
        );
    };

    const originalError = console.error;
    console.error = (...args: any[]) => {
        if (isIgnoredWarning(args[0])) {
            return;
        }
        originalError.apply(console, args);
    };

    const originalWarn = console.warn;
    console.warn = (...args: any[]) => {
        if (isIgnoredWarning(args[0])) {
            return;
        }
        originalWarn.apply(console, args);
    };
}

export async function goToLogin() {
    setAuthtoken("");
    clearJwtToken();
    let mApp: Promise<{App:FC<{}>}>;
    mApp = import("./App") as any;
    const {App} = await mApp;

    render(<App />, rootEle);
}

export async function bootstrap() {
    const jwtToken = getJwtToken();
    const isPublicSurvey = location.pathname.indexOf("/survey/public/") !== -1 || location.pathname.indexOf("/surveys/public/") !== -1;
    const isPublicTutorial = location.pathname.indexOf("/tutorial/public/") !== -1 || location.pathname.indexOf("/tutorials/public/") !== -1;
    const isPublicService = location.pathname.indexOf("/dich-vu-cong") !== -1;
    const isPublicScoreLookup = location.pathname.indexOf("/tra-cuu-diem") !== -1 || location.pathname.indexOf("/tra-cuu-diem-thi") !== -1;

    if (jwtToken) {
        setAuthtoken(jwtToken);
    } else {
        setAuthtoken("");
        if (location.pathname !== "/signIn" && location.pathname.indexOf("/resetPassword") === -1 && !isPublicSurvey && !isPublicTutorial && !isPublicService && !isPublicScoreLookup) {
            location.pathname = "/signIn";
            goToLogin();
            return;
        }
    }

    let mApp: Promise<{App:FC<{}>}>;
    mApp = import("./App") as any;
    const {App} = await mApp;
    render(<App />, rootEle);
}

bootstrap();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
import * as serviceWorker from './serviceWorker';
serviceWorker.unregister();
